import React from 'react';
import { I18n, Translate } from 'react-redux-i18n';
import '../styles/item.scss';

const Item = ({ step }) => {
  const handleClick = (link) => {
    if (!link) return;
    window.open(link, '_blank');
  };
  return (
    <div className={'welcome-item'}>
      <div className={'welcome-item-image-container ' + step.key}>
        <img className={'welcome-item-image'} src={step.image} alt={step.key} />
      </div>
      <div className={'welcome-item-content-container'}>
        {step.usedKey.map((key) => (
          <p
            className={`welcome-item-${key}`}
            key={key}
            onClick={() => key.includes('button') && handleClick(step.link)}
          >
            <Translate value={`welcome.${step.key}.${key}`} dangerousHTML />
          </p>
        ))}
      </div>
    </div>
  );
};

export default Item;
